export default __webpack_public_path__ + "static/media/angpao-bg-mobile.0e260e6b.webp";